import axios from 'axios';
import dayjs from 'dayjs';

import * as utils from '../utils/utils.js';

import 'dayjs/locale/is.js';

export const fetchPastSessions = async (owner_id) => {
    var session_url =
        utils.backendUrl() + '/past_sessions?owner_id=' + owner_id;

    try {
        const response = await axios.get(session_url, {
            owner_id: owner_id,
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
            },
        });

        let sessions = response.data.pastSessions;

        sessions.sort(function (a, b) {
            let dateA = dayjs(a.timestamp);
            let dateB = dayjs(b.timestamp);
            return dateA > dateB ? -1 : dateA === dateB ? 0 : 1;
        });

        return sessions;
    } catch (err) {
        console.error(err);
        throw err;
    }
};
